export const analyticsKpiThunkNames = {
    fetchAnalyticsKpi: 'fetchAnalyticsKpi',
};
